<template>
  <carousel v-if="articles.length" :perPage="1">
    <slide
      v-for="(article, index) in articles"
      :key="article.author"
    >
      <router-link :to="`/article/${index + 1}`">
        <Article
          :id="index + 1"
        />
      </router-link>
    </slide>
  </carousel>
</template>

<script>
  // import {mapState} from 'vuex'
  import Article from './Article'

  export default {
    name: 'hello',
    components: {
      Article
    },
    data () {
      return {
        msg: 'Welcome to Your Vue.js PWA'
      }
    },
    computed: {
      articles () {
        return this.$store.getters.listArticles
      }
    }
  }
</script>

<style>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #35495E;
  }

  .VueCarousel-dot {
    padding: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue